













































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { IUserData } from '@/shared/models/auth'
import Loader from '@/components/common/Loader.vue'
import BezeButton from '@/components/common/BezeButton.vue'
import BezeInput from '@/components/common/BezeInput.vue'
import { mask } from 'vue-the-mask'
import UserAPI from '@/api/users'

@Component({
  components: {
    Loader,
    BezeButton,
    BezeInput
  },
  directives: {
    mask
  }
})
export default class UserInfo extends Vue {
  isEditable = false
  isBtnLoading = false
  userProfile: IUserData | null = null
  password = {
    current: '',
    new: ''
  }

  get userData(): IUserData {
    return this.$store.getters.userData
  }

  created(): void {
    this.userProfile = JSON.parse(JSON.stringify(this.userData))
  }

  changePassword(): void {
    UserAPI.updatePassword(this.userData?.id + '', this.password.new).then(response => {
      console.log(response.data)
    })
  }

  updateUser(): void {
    this.isBtnLoading = true
    const userModel = {
      first_name: this.userProfile?.first_name,
      last_name: this.userProfile?.last_name,
      email: this.userProfile?.email,
      address: this.userProfile?.shipping.address_1,
      phone: this.userProfile?.billing.phone
    }
    UserAPI.updateUser(this.userData?.id + '', userModel).then(() => {
      const userID = this.userData?.id
      localStorage.removeItem('user-data')
      this.$store.dispatch('getUserData', userID).then(() => {
        this.$toasted.success('Информация успешно обновлена')
        this.isEditable = false
        this.isBtnLoading = false
      })
    }).catch(error => {
      this.$toasted.error(`Ошибка при обновлении. ${error?.response?.data.message}`)
      this.isBtnLoading = false
    })
  }
}
